export const landerRefKey = 'sf_referral';
export const landerSourceName = 'WEB';
export const landerUtmSource = 'Университет';
